<template>
  <div
    :class="
      $vuetify.breakpoint.xsOnly
        ? 'px-0 py-2 animate__animated animate__fadeIn'
        : 'pa-4 animate__animated animate__fadeIn'
    "
  >
    <h2 class="title_tab mb-3">
      โปรโมชัน
      <v-btn
        :class="$vuetify.breakpoint.xsOnly ? 'float-right' : 'float-right mt-2'"
        color="button"
        dark
        small
        @click="openDialog('')"
      >
        <v-icon x-small class="mr-1">mdi-plus</v-icon>เพิ่มโปรโมชัน
      </v-btn>
    </h2>
    <!-- <pre>{{all_promotion_data}}</pre> -->
    <div>
      <v-data-table
        :headers="headers"
        :items="all_promotion_data"
        hide-default-header
        :items-per-page="max_per_page"
        class="data_table_footer"
        :page.sync="page"
        @page-count="pageCount = $event"
      >
        <template v-slot:top v-if="!$vuetify.breakpoint.xsOnly">
          <div class="pt-2" v-if="!$vuetify.breakpoint.xsOnly">
            <v-card
              flat
              style="border-radius: 10px"
              color="card_header"
              class="px-4 location-header"
            >
              <v-row>
                <!--  :sm="index==1||index==3?2:(index==4?2:2)" -->
                <v-col
                  v-for="(item, index) in headers"
                  :key="index"
                  :cols="index == 5 ? 1 : 2"
                  :sm="index == 3 ? 3 : index == 4 ? 2 : index == 5 ? 1 : 2"
                  :md="index == 4 ? 1 : index == 3 ? 3 : 2"
                  >{{ item.text }}</v-col
                >
              </v-row>
            </v-card>
          </div>
        </template>
        <!-- <template v-slot:no-data>
          <div class="text-center pa-12">
            <p
              class="py-6"
              :style="$vuetify.breakpoint.xsOnly?'font-size:16px;':'font-size:22px;'"
            >ไม่มีข้อมูล</p>
          </div>
        </template>-->
        <template v-slot:body="{ items }" v-if="all_promotion_data != ''">
          <div v-if="!$vuetify.breakpoint.xsOnly">
            <v-card
              flat
              style="border-radius: 10px"
              color="card_body"
              v-for="(item, index) in items"
              :key="index"
              class="my-2 px-4 py-1 location-text"
            >
              <v-row align="center" justify="center" class="font-kanit-bold">
                <v-col cols="2" align="center" justify="center">
                  <!-- <pre>{{item}}</pre> -->
                  <v-card
                    tile
                    v-if="item.image_path_by_id == ''"
                    class="text-center py-8"
                  >
                    <v-progress-circular
                      :width="3"
                      color="red"
                      indeterminate
                    ></v-progress-circular>
                  </v-card>
                  <v-img
                    v-if="item.image_path_by_id != ''"
                    :src="item.image_path_by_id"
                    aspect-ratio="1.6"
                  ></v-img>
                </v-col>
                <v-col cols="2" sm="2">{{ item.topic }}</v-col>
                <v-col cols="2">฿ {{ formatNumber(item.price) }}</v-col>
                <v-col cols="2" sm="3" md="3">{{
                  item.start_date == null && item.end_date == null
                    ? "ปัจจุบัน"
                    : (item.start_date == null
                        ? ""
                        : formatDate(item.start_date)) +
                      " - " +
                      (item.end_date == null && item.start_date != null
                        ? "ปัจจุบัน"
                        : formatDate(item.end_date))
                }}</v-col>
                <v-col
                  :class="$vuetify.breakpoint.smOnly ? 'pl-3' : ''"
                  cols="2"
                  sm="2"
                  md="1"
                >
                  <v-icon
                    :x-small="!$vuetify.breakpoint.smOnly"
                    :small="$vuetify.breakpoint.smOnly"
                    :class="
                      $vuetify.breakpoint.smOnly ? 'mb-1 px-1' : 'mb-1 pr-1'
                    "
                    :color="item.status == 'active' ? 'green' : ''"
                    >mdi-circle</v-icon
                  >

                  <span v-if="!$vuetify.breakpoint.smOnly">{{
                    item.status == "active" ? "active" : "inactive"
                  }}</span>
                </v-col>
                <v-col cols="2" sm="1" md="2">
                  <v-btn
                    class="float-right font-kanit-light"
                    outlined
                    :small="!x_tablet"
                    :x-small="x_tablet"
                    style="background: white"
                    @click="openDialog(item)"
                    >รายละเอียด</v-btn
                  >
                </v-col>
              </v-row>
            </v-card>
          </div>
          <div class="pa-0" v-if="$vuetify.breakpoint.xsOnly">
            <v-card
              flat
              color="card_header"
              v-for="(item, index) in items"
              :key="index"
              class="my-2 px-4 py-0 pr-3"
            >
              <v-row align="center" justify="center" class="pa-0">
                <v-col cols="12" class="py-0">
                  <v-row class="py-0">
                    <v-col cols="5" class="location-xs-header py-0 pt-2"
                      >ชื่อสินค้า</v-col
                    >
                    <v-col
                      cols="7"
                      style="background: #f2f2f2"
                      class="location-xs-text py-0 pt-2"
                      >{{ item.topic }}</v-col
                    >
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-row class="py-0">
                    <v-col cols="5" class="location-xs-header py-0 pt-1"
                      >ราคาโปรโมชัน</v-col
                    >
                    <v-col
                      cols="7"
                      style="background: #f2f2f2"
                      class="location-xs-text py-0 pt-1"
                      >฿ {{ formatNumber(item.price) }}</v-col
                    >
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-row class="py-0">
                    <v-col cols="5" class="location-xs-header py-0 pt-1"
                      >ระยะเวลาโปรโมชัน</v-col
                    >
                    <v-col
                      cols="7"
                      style="background: #f2f2f2"
                      class="location-xs-text py-0 pt-1"
                      >{{
                        item.start_date == null && item.end_date == null
                          ? "ปัจจุบัน"
                          : (item.start_date == null
                              ? ""
                              : formatDate(item.start_date)) +
                            " - " +
                            (item.end_date == null && item.start_date != null
                              ? "ปัจจุบัน"
                              : formatDate(item.end_date))
                      }}</v-col
                    >
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-row class="py-0">
                    <v-col cols="5" class="location-xs-header py-0 pt-1"
                      >สถานะ</v-col
                    >
                    <v-col
                      cols="7"
                      style="background: #f2f2f2"
                      class="location-xs-text py-0 pt-1"
                    >
                      <v-icon
                        x-small
                        class="mb-1 pr-1"
                        :color="item.status == 'active' ? 'green' : ''"
                        >mdi-circle</v-icon
                      >

                      <span v-if="!$vuetify.breakpoint.smOnly">{{
                        item.status == "active" ? "active" : "inactive"
                      }}</span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-row class="py-0">
                    <v-col
                      cols="5"
                      class="location-xs-header py-0 pt-1 pb-2"
                    ></v-col>
                    <v-col
                      cols="7"
                      style="background: #f2f2f2"
                      class="location-xs-text py-0 pt-1 pb-2"
                    >
                      <v-btn
                        class="font-kanit-bold my-1"
                        outlined
                        block
                        small
                        @click="openDialog(item)"
                        style="background: white"
                        >รายละเอียด</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </template>
      </v-data-table>
    </div>
    <!-- 
    <div class="text-center">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" xs="12" sm="10" md="8" xl="8" lg="7">
            <v-container class="max-width">
              <v-pagination
                v-model="page"
                class="my-4"
                :length="pageCount"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </div> -->
    <DialogPromotion ref="dialog" @getpromotion="getData()" />
  </div>
</template>
<script>
import DialogPromotion from "../dialogsetting/DialogPromotion";
export default {
  components: { DialogPromotion },
  data() {
    return {
      header_token: { headers: { token: this.$session.get("token") } },
      page: 1,
      length_page: 1,
      max_per_page: 10,
      pageCount: 0,
      headers: [
        {
          text: "ภาพสินค้า",
          sortable: false,
          value: "image",
        },
        {
          text: "ชื่อสินค้า",
          sortable: false,
          value: "name",
        },
        {
          text: "ราคาโปรโมชัน",
          sortable: false,
          value: "period",
        },
        {
          text: "ระยะเวลาโปรโมชัน",
          sortable: false,
          value: "tel",
        },
        {
          text: "สถานะ",
          sortable: false,
          value: "status",
        },
        {
          text: "",
          sortable: false,
          value: "action",
        },
      ],
      all_promotion_data: [],
      show_all_promotion_data: [],
    };
  },

  mounted() {},
  created() {
    this.getData();
  },
  computed: {
    x_tablet() {
      if (this.$vuetify.breakpoint.width < 680) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    // page(value) {
    //   if (this.all_promotion_data != []) {
    //     let show_data_promotion = [];
    //     this.show_all_promotion_data = [];
    //     this.all_promotion_data.forEach((element, index) => {
    //       if (
    //         index >= (value - 1) * this.max_per_page &&
    //         index < value * this.max_per_page
    //       ) {
    //         show_data_promotion.push(element);
    //       }
    //     });
    //     this.show_all_promotion_data = show_data_promotion;
    //   }
    // },
  },
  methods: {
    getData() {
      let promotion = [];
      let promotion_active = [];
      let promotion_inactive = [];
      let promotion_status = [];
      let promotion_data = [];
      const time_thai_late = 7 * 60 * 60 * 1000;
      const time_up_late_1_day = 24 * 60 * 60 * 1000;
      var date_now = new Date().toISOString().substr(0, 10);

      this.all_promotion_data = [];
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/promotion", this.header_token)
        .then((response) => {
          // console.log(response.data.result);
          promotion = response.data.result;
          let check_length = response.data.result.length;
          this.length_page = check_length / this.max_per_page;
          this.length_page = parseInt(this.length_page);

          if (check_length % this.max_per_page != 0) {
            this.length_page += 1;
          }
          if (response.data.result && response.data.status == "OK") {
            promotion.forEach((element) => {
              if (element.end_date == null) {
                element.image_path_by_id = "";
                element.status = "active";
                promotion_active.push(element);
              } else if (
                Date.parse(element.end_date) +
                  time_up_late_1_day -
                  (Date.parse(date_now) + time_thai_late) <
                0
              ) {
                element.image_path_by_id = "";
                element.status = "inactive";
                promotion_inactive.push(element);
              } else {
                element.image_path_by_id = "";
                element.status = "active";
                promotion_active.push(element);
              }
            });
            // console.log(promotion_active);
            // console.log(promotion_inactive);
            promotion_status = promotion_active.concat(promotion_inactive);

            // console.log(promotion_status);
            // promotion = promotion.sort(function (a, b) {
            //   return a.status - b.status;
            // });
            // console.log(promotion);

            // var image_path_by_id = null;

            // this.axios({
            //   url:
            //     process.env.VUE_APP_API + "/api/v1/image/" + element.image_id,
            //   method: "GET",
            //   responseType: "blob", // important
            //   headers: { token: this.$session.get("token") },
            // }).then((response) => {
            //   var url = window.URL.createObjectURL(new Blob([response.data]));
            //   image_path_by_id = url;
            //   element.image_path_by_id = image_path_by_id;
            //   promotion_data.push(element);
            // });

            this.all_promotion_data = promotion_status;
            // let get_show_data_promotion = [];
            // this.show_all_promotion_data = [];
            // this.all_promotion_data.forEach((element, index) => {
            //   if (index >= 0 * this.max_per_page && index < this.max_per_page) {
            //     get_show_data_promotion.push(element);
            //   }
            // });
            // this.show_all_promotion_data = get_show_data_promotion;
            this.previewImage();
          }
        });
    },
    previewImage() {
      var url;
      // this.image_promotion = null;
      // console.log(id);
      this.all_promotion_data.forEach((element, index) => {
        this.axios({
          url:
            process.env.VUE_APP_API + "/api/v1/image/" + element.image.image_id,
          method: "GET",
          responseType: "blob", // important
          headers: { token: this.$session.get("token") },
        })
          .then((response) => {
            url = window.URL.createObjectURL(new Blob([response.data]));
            // image_path_by_id = url;
            // element.image_path_by_id = image_path_by_id;
            // promotion_data.push(element);
            this.all_promotion_data[index].image_path_by_id = url;
          })
          .catch((err) => {
            this.all_promotion_data[index].image_path_by_id =
              "ไม่สามารถโหลดรูปได้";
          });
      });

      // return url;
    },
    openDialog(item) {
      this.$refs.dialog.open(item);
    },
    formatDate(fulldate) {
      if (!fulldate) return null;
      const [date, time] = fulldate.split(" ");
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year[2] + year[3]}`;
    },
    formatNumber(num) {
      return new Intl.NumberFormat().format(num);
    },
  },
};
</script>

